<template>
    <vue-element-loading :active="active" color="#fff" :background-color="getBgColor()" :text="loaderText" :text-style="{fontSize: '1.3em'}" :is-full-screen="isFullScreen"/>
</template>

<script>
    export default {
        name: "Loader",
        props: {
            active: Boolean,
            bgColor: {
                type: String,
                default: function () {
                    return '#'
                }
            },
            text: {
                type: String,
                default: function () {
                    return "";
                }
            },
            isFullScreen: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
        },
        data() {
            return {
                timeChecker: null,
                loadingToLongFlag: false
            }
        },
        computed: {
            theme() {
                return this.$store.getters['cfg/get'].global.theme;
            },
            loaderText() {
                return this.loadingToLongFlag ? "Ładowanie trwa dłużej niż powinno" : this.text;
            }
        },
        methods: {
            getBgColor() {
                return (this.bgColor === '#' ? this.theme.themeColor1 : this.bgColor)
            }
        }
    }
</script>

<style scoped>

</style>